import { render, staticRenderFns } from "./SolutionView.vue?vue&type=template&id=5cc7fa24&scoped=true"
import script from "./SolutionView.vue?vue&type=script&lang=js"
export * from "./SolutionView.vue?vue&type=script&lang=js"
import style0 from "./SolutionView.vue?vue&type=style&index=0&id=5cc7fa24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7fa24",
  null
  
)

export default component.exports